import React from 'react'
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import img1 from '../assets/icons8-facebook-48.png'
import img2 from '../assets/icons8-twitterx-48.png'
import img3 from '../assets/icons8-telegram-48.png'
import img4 from '../assets/icons8-linked-in-48.png'
import img5 from '../assets/icons8-whatsapp-48.png'
import img6 from '../assets/Icon PNG.png'

const socialLinks = [
  { img: img1, alt: 'Facebook', href: '#' },
  { img: img2, alt: 'Twitter / X', href: '#' },
  { img: img3, alt: 'Telegram', href: '#' },
  { img: img4, alt: 'LinkedIn', href: '#' },
  { img: img5, alt: 'WhatsApp', href: '#' },
];

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    // TODO: hook up newsletter subscription
  };

  return (
    <div className='footer'>
      <MDBFooter className='text-center text-lg-start text-muted'>
        <section className='pt-1'>
          <MDBContainer className='text-center text-md-start mt-5'>
            <MDBRow className='mt-3'>
              <MDBCol md="4" lg="4" xl="3" className='mx-auto footer-first-col border-bottom'>
                <h6 className='text-uppercase fw-bold mb-4 font-quiksand d-flex align-items-center'>
                  <img src={img6} className='footer-logo' alt='Skill Worker logo' />
                  Skill Worker
                </h6>
                <p className='company-slogan'>EVERY JOB MATTERS.</p>
                <h6>Follow us</h6>
                <div className='footer-icon'>
                  {socialLinks.map((social) => (
                    <a
                      key={social.alt}
                      href={social.href}
                      target='_blank'
                      rel='noopener noreferrer'
                      aria-label={social.alt}
                    >
                      <img src={social.img} alt={social.alt} />
                    </a>
                  ))}
                </div>
              </MDBCol>

              <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4 border-bottom'>
                <h6 className='text-uppercase fw-bold mb-4 font-quiksand'>Menu</h6>
                <p>
                  <a href='/' className='text-reset'>
                    Home
                  </a>
                </p>
                <p>
                  <Link to='/AboutUs' className='text-reset'>
                    About Us
                  </Link>
                </p>
                <p>
                  <Link to='/OurServices' className='text-reset'>
                    Services
                  </Link>
                </p>
                <p>
                  <Link to='/ContactUs' className='text-reset'>
                    Contact Us
                  </Link>
                </p>
              </MDBCol>

              <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4 border-bottom'>
                <h6 className='text-uppercase fw-bold mb-4 font-quiksand'>Services</h6>
                <p>
                  <a href='#!' className='text-reset'>
                    Health Care Assistance
                  </a>
                </p>
                <p>
                  <a href='#!' className='text-reset'>
                    Support Worker
                  </a>
                </p>
                <p>
                  <a href='#!' className='text-reset'>
                    Social Care &amp; Housing
                  </a>
                </p>
                <p>
                  <a href='#!' className='text-reset'>
                    Nursing
                  </a>
                </p>
              </MDBCol>

              <MDBCol md="4" lg="4" xl="4" className='mx-auto mb-4'>
                <h6 className='text-uppercase fw-bold mb-4 font-quiksand'>Newsletters</h6>
                <p>
                  Subscribe to get updates and information.
                  Don't worry, we won't send spam!
                </p>
                <form className='email d-flex' onSubmit={handleSubscribe}>
                  <input
                    type='email'
                    required
                    className='w-100 bg-transparent'
                    placeholder='Enter your email'
                  />
                  <button className='btn subscribe-btn' type='submit'>
                    Subscribe
                  </button>
                </form>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
      </MDBFooter>
    </div>
  );
}

export default Footer